import axios from 'axios';

export const getCep = cep => {
  const cepClean = cep.replace(/\D/g, '');
  const validacep = /^[0-9]{8}$/;
  if (cepClean !== '' && validacep.test(cepClean)) {
    axios.defaults.headers.common = {};
    return axios
      .get(`https://brasilapi.com.br/api/cep/v1/${cepClean}`, null)
      .then(response => {
        return response.data;
      })
      .catch(err => console.error(err));
  }
  return false;
};
